import { render, staticRenderFns } from "./QueriesExports.vue?vue&type=template&id=ad022cf4&scoped=true"
import script from "./QueriesExports.vue?vue&type=script&lang=ts"
export * from "./QueriesExports.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad022cf4",
  null
  
)

export default component.exports